import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { getFirstAvailableKlarnaMethod } from '../utils/methods';
import { createScript } from '../utils/script';
import { initSession } from '../utils/session';

export const useKlarna = (paymentMethods) => {
  const [klarnaSessionData, setKlarnaSessionData] = useState({});

  useDeepCompareEffect(() => {
    const klarnaWallet = getFirstAvailableKlarnaMethod(paymentMethods);
    if (klarnaWallet) {
      const initKlarna = async (code) => {
        createScript('klarna-script-tag');
        const sessionData = await initSession(code);
        setKlarnaSessionData(sessionData);
      };

      initKlarna(klarnaWallet.code);
    }
  }, [paymentMethods]);

  const refetchKlarnaSession = async (code) => {
    const sessionData = await initSession(code);
    setKlarnaSessionData(sessionData);
  };

  return { klarnaSessionData, refetchKlarnaSession };
};
